import { render, staticRenderFns } from "./UnresolvedMealsIssue.vue?vue&type=template&id=6ab4a057&scoped=true"
import script from "./UnresolvedMealsIssue.vue?vue&type=script&lang=js"
export * from "./UnresolvedMealsIssue.vue?vue&type=script&lang=js"
import style0 from "./UnresolvedMealsIssue.vue?vue&type=style&index=0&id=6ab4a057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab4a057",
  null
  
)

export default component.exports